import constants from 'app/constants';
import { useAuthSelector } from 'app/data/auth';
import {
  Button,
  Dialog,
  DialogAlert,
  DialogLoading,
  DialogProps,
} from 'app/design-lib';
import { DialogActions } from 'app/design-lib/components/DialogActions';
import { DialogContent } from 'app/design-lib/components/DialogContent';
import { DialogHeader } from 'app/design-lib/components/DialogHeader';
import { useAccountStripeCustomerQuery } from 'app/hooks/queries/account';
import { isBefore } from 'date-fns';
import { gql, request } from 'graphql-request';
import { useState } from 'react';
import { useHistory } from 'react-router-dom';

interface ReactivateSubDialogProps extends Omit<DialogProps, 'children'> {}

export const ReactivateSubDialog = (props: ReactivateSubDialogProps) => {
  return (
    <Dialog {...props}>
      {' '}
      <ReactivateSubDialogContent {...props} />
    </Dialog>
  );
};

const ReactivateSubDialogContent = (props: ReactivateSubDialogProps) => {
  const { data } = useAccountStripeCustomerQuery();

  const sub = data?.data?.subscriptions?.data?.[0];
  const { status, current_period_end, trial_end } = sub ?? {};

  const { auth_token } = useAuthSelector();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const reactivateSub = async () => {
    setIsSubmitting(true);
    try {
      const cancelResp = await request(
        `${constants.env.REACT_APP_CIO_API_SERVER}/api/graphql`,
        gql`
          mutation stripeCustomerMutate($data: JSON) {
            stripeCustomerMutate(data: $data) {
              success
              message
              data
            }
          }
        `,
        {
          data: {
            action: 'reactivateSubscription',
            data: {},
          },
        },
        // @ts-ignore
        { authorization: auth_token },
      );
      console.log('cancel response', cancelResp);
      setIsSuccess(true);

      // setTimeout(() => {
      //   router.push(`/logout`);
      // }, 5000);
    } catch (err) {
      console.error(err);
      setErrorMessage('Error in canceling subscription');
    }
    setIsSubmitting(false);
  };

  let currentCycleEndDate = new Date(current_period_end * 1000);

  const today = new Date();
  if (isBefore(currentCycleEndDate, today)) {
    currentCycleEndDate = today;
  }

  return (
    <>
      <DialogHeader
        title={
          isSuccess
            ? 'Subscription reactivated'
            : isSubmitting
            ? 'Reactivating subscription'
            : `Reactivate subscription`
        }
        onClose={props.onClose}
        subTitle={isSubmitting ? 'Please wait...' : ''}
      />
      {!isSubmitting && errorMessage ? (
        <DialogAlert
          onClose={() => setErrorMessage('')}
          errorMessage={errorMessage}
        />
      ) : null}
      <DialogContent>
        {isSuccess ? (
          <div className={'w-full text-md text-center'}>
            <p>We're glad you changed your mind!</p>
            <br />
            <p>
              your subscription will begin on{' '}
              {currentCycleEndDate.toLocaleDateString()}
            </p>
          </div>
        ) : isSubmitting ? (
          <DialogLoading
            label={'Reactivating your subscription...'}
            secondaryText={'This may take a moment.'}
          />
        ) : (
          <div className={'text-center '}>
            <p className={'text-md'}>
              Are you sure you would like to reactivate your subscription?
            </p>
            <br />
            <p className={'text-md'}>
              You will be billed on {currentCycleEndDate.toLocaleDateString()}
            </p>
          </div>
        )}
      </DialogContent>
      {isSubmitting ? null : (
        <DialogActions>
          {isSuccess ? (
            <Button
              variant={'fill'}
              color={'accent'}
              size={'md'}
              onClick={props.onClose}
            >
              Dismiss
            </Button>
          ) : (
            <Button
              variant={'fill'}
              color={'attention'}
              size={'md'}
              onClick={reactivateSub}
            >
              Reactivate subscription
            </Button>
          )}
        </DialogActions>
      )}
    </>
  );
};

export default ReactivateSubDialog;
